// @goodgym/graphql/mutations/UpdateGroupFitnessActivity.ts
import { useUpdateGroupFitnessActivityMutation } from "@goodgym/graphql/hooks";
import { useNavigate } from "react-router-dom";
import { useConfirm } from "@goodgym/hooks";

type UpdateGroupFitnessActivityInput = {
  id: string;
  sessionSlug: string;
  description?: string;
  startedAt?: string;
  distance?: number;
  type?: string;
  addressId?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  postCode?: string;
  region?: string;
  accessNotes?: string;
  otherInformation?: string;
  runReturn?: boolean;
  toilets?: boolean;
  bagDrop?: boolean;
  accessibleToilets?: boolean;
};

export const useUpdateGroupFitnessActivity = () => {
  const navigate = useNavigate();
  const { confirm } = useConfirm();

  const [updateGroupFitnessActivity] = useUpdateGroupFitnessActivityMutation({
    onError: console.error,
  });

  return (params: UpdateGroupFitnessActivityInput) =>
    async (e: React.MouseEvent) => {
      e.preventDefault();

      confirm({
        title: "Edit this group fitness activity?",
        text: "You’re about to update the activity details.",
        alert: false,
        onConfirm: async () => {
          const result = await updateGroupFitnessActivity({
            variables: { ...params },
          });

          const updated =
            result.data?.updateGroupFitnessActivity.groupFitnessActivity;

          if (!updated) {
            alert("Error updating activity.");
          } else {
            navigate(`/v3/sessions/${params.sessionSlug}`);
          }
        },
      });
    };
};
